import axios from "axios";

// const GEO_API_TOKEN = "ePAntFijpVIOaKPkO8sfzIKCxUa2dhNJ7vCiZOKtBwmXqFr3OtOb6tOSXV4inHO5";
const GEO_API_TOKEN = "75f005d7b6beabdb07cd4c972391b45d62d44dd7e3f95c0861de617f35c08f04";

const geoHttp = axios.create({
  baseURL: "https://geo.systha.com",
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
    Authorization: `Bearer ${GEO_API_TOKEN}`,
  },
});

export function getGeoIp(ip: string) {
  return geoHttp
    .get("/api/geoip", {
      params: { ip },
    })
    .then((res) => res.data);
}

export function searchAddress(params: {
  full_address?: string;
  number?: string;
  street?: string;
  unit?: string;
  city?: string;
  state?: string;
  zipcode?: string;
  country?: string;
  latitude?: number;
  longitude?: number;
  limit?: number;
}) {
  return geoHttp
    .post("/api/address-importer/search", {
      full_address: params.full_address,
      limit: params.limit,
    })
    .then((res) => res.data);
}

export default geoHttp;
